module.exports = __webpack_public_path__ + "img/hr-tree-05-i-leaves.4ec494ae.png";